import { constants } from "redux/constants/redux-constants";

export const setSearchKeyword = (keyword, context) => ({
    type: constants.SET_SEARCH_KEYWORD,
    payload: { keyword, context },
  });

// Published by the server-side DataTable datasource when a keyword-driven query
// settles, so the voice copilot's filter action can report the REAL outcome
// (count / no_results / error) instead of confirming success on dispatch.
// `status` is "success" | "empty" | "error"; `at` is a monotonic timestamp the
// waiter uses to ignore stale results from a previous search. `keyword` is the
// query this result actually settled FOR — select's K3 interlock matches it
// against the active keyword so a rank can never resolve against a pre-filter
// grid (wrong patient).
export const setSearchResult = (context, { status, count = 0, at, keyword }) => ({
  type: constants.SET_SEARCH_RESULT,
  payload: { context, status, count, at, keyword },
});